import { render, staticRenderFns } from "./AddonForm.vue?vue&type=template&id=a50149c2"
import script from "./AddonForm.vue?vue&type=script&lang=ts"
export * from "./AddonForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports